import React from "react";
import { Select } from "antd";
import { getTags } from "../api/tags";
const { Option } = Select;

export const Tags = () => {
  const [tgs, setTags] = React.useState([]);
  React.useEffect(() => {
    gttgs();
  }, []);

  async function gttgs() {
    const t: any = await getTags();
    setTags(t.data.tags);
  }

  return tgs.map((i: any, n: any) => (
    <Option key={n} value={i.name}>
      {i.name}
    </Option>
  ));
};
